<template>
<section class="py-16 bg-gray-50">
  <div class="container mx-auto px-6">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-800 mb-2">常见问题</h2>
      <p class="text-gray-600">您可能想知道的问题</p>
    </div>
    <div class="max-w-3xl mx-auto">
      <div v-for="(faq, index) in localFaqs" :key="index" class="mb-4">
        <div class="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center cursor-pointer" @click="toggleFaq(index)">
          <h3 class="font-semibold text-gray-800">{{ faq.question }}</h3>
          <i :class="faq.isOpen ? 'fas fa-chevron-up text-[#76B900]' : 'fas fa-chevron-down text-gray-400'"></i>
        </div>
        <div v-show="faq.isOpen" class="bg-white p-4 rounded-b-lg shadow-sm mt-1">
          <p class="text-gray-600">{{ faq.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'FAQSection',
  props: {
    faqs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      localFaqs: this.faqs.map(faq => ({ ...faq }))
    }
  },
  watch: {
    faqs: {
      handler(newFaqs) {
        this.localFaqs = newFaqs.map(faq => ({ ...faq }))
      },
      deep: true
    }
  },
  methods: {
    toggleFaq(index) {
      this.localFaqs[index].isOpen = !this.localFaqs[index].isOpen;
    }
  }
}
</script> 